import { useState } from "react"
import { NavLink } from "react-router-dom"
import { ChevronLeft, ChevronRight, FolderTree } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { tools } from "@/tools/registry"

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(true)

  const items = [
    { to: "/", name: "文件管理器", icon: FolderTree, end: true },
    ...tools.map((t) => ({ to: `/tools/${t.id}`, name: t.name, icon: t.icon, end: false })),
  ]

  return (
    <aside
      className={cn(
        "shrink-0 border-r bg-card flex flex-col transition-[width] duration-150",
        collapsed ? "w-12" : "w-48"
      )}
    >
      <nav className={cn("flex-1 overflow-y-auto py-2", collapsed && "flex flex-col items-center")}>
        {items.map((item) => {
          const Icon = item.icon
          const link = (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-md text-sm transition-colors",
                  "hover:bg-accent hover:text-accent-foreground",
                  isActive && "bg-accent text-accent-foreground font-medium",
                  collapsed ? "justify-center w-10 h-10 my-2" : "mx-1 gap-2 px-2 py-1.5 my-0.5"
                )
              }
            >
              <Icon className="w-4 h-4 shrink-0" />
              {!collapsed && <span className="truncate">{item.name}</span>}
            </NavLink>
          )
          return collapsed ? (
            <Tooltip key={item.to}>
              <TooltipTrigger asChild>{link}</TooltipTrigger>
              <TooltipContent side="right">{item.name}</TooltipContent>
            </Tooltip>
          ) : (
            link
          )
        })}
      </nav>
      <div className="border-t p-1">
        <Button
          variant="ghost"
          size="icon"
          className="w-full h-8"
          onClick={() => setCollapsed((v) => !v)}
          title={collapsed ? "展开侧边栏" : "折叠侧边栏"}
        >
          {collapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
        </Button>
      </div>
    </aside>
  )
}
